import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-labo-header',
  templateUrl: '../../../../../assets/html/webshoplabo.html',
  styleUrls: ['./header.component.css']
})
export class LaboHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    var t = $('[data-parallax="scroll"]').data('imageSrc');
    $('[data-parallax="scroll"]').parallax({imageSrc: t});
  }

}
